import { Box, Flex, Text, Tooltip } from '@chakra-ui/react';
import { faEdit, faPlus, faTag } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ButtonText } from '@morressier/alembic';
import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { fetchWorkspaceTags } from 'src/api/queries';
import AddingUserTagsModal from './AddingUserTagsModal';
import { ITags } from '@publishing-engine/domain/types/AuthorType';
import TagDetailsPopover from './TagDetailsPopover';

interface Props {
  allTags: ITags[];
  orgId: string;
  userId: string;
  workspaceId: string;
  disableTagAction?: boolean;
}

const ManageAuthorTags: React.FC<Props> = ({
  allTags,
  orgId,
  userId,
  workspaceId,
  disableTagAction
}) => {
  const [showAddTagModal, setShowAddTagModal] = useState<boolean>(false);

  const filter = 'users';

  const { data: manageTags } = useQuery({
    queryKey: ['workspace-tags', { workspaceId, filter }],
    queryFn: () =>
      workspaceId ? fetchWorkspaceTags(workspaceId, filter) : null
  });

  const manageTagsData = manageTags?.collection ?? [];
  const updatedUserTags = manageTags?.collection.filter(tag =>
    allTags?.some(userTag => userTag.id === tag.id)
  );

  const tagsExist = allTags?.length > 0;

  return (
    <>
      {showAddTagModal ? (
        <AddingUserTagsModal
          isOpen={showAddTagModal}
          onClose={() => setShowAddTagModal(false)}
          data={manageTagsData}
          allTags={allTags || []}
          userId={userId}
          orgId={orgId}
        />
      ) : null}

      <Flex
        gap={2}
        alignItems={{ base: 'flex-start', md: 'center' }}
        flexWrap="wrap"
      >
        <FontAwesomeIcon icon={faTag} />
        <Flex gap={2} flexWrap="wrap" flex="1">
          {updatedUserTags?.length ? (
            updatedUserTags.map(tag => (
              <TagDetailsPopover key={tag.id} tagDetail={tag} />
            ))
          ) : (
            <Text textStyle={'textContext'}>No Tags added to this User yet.</Text>
          )}
        </Flex>
        <Flex>
          <Tooltip
            hasArrow
            placement="auto"
            label={
              disableTagAction
                ? 'Tag actions are only available for active users'
                : ''
            }
          >
            <Box>
              <ButtonText
                size="regular"
                variant="primary"
                fontSize={'sm'}
                iconLeft={
                  <FontAwesomeIcon icon={tagsExist ? faEdit : faPlus} />
                }
                onClick={() => setShowAddTagModal(true)}
                isDisabled={!userId || disableTagAction}
              >
                {tagsExist ? 'Edit' : 'Add tags'}
              </ButtonText>
            </Box>
          </Tooltip>
        </Flex>
      </Flex>
    </>
  );
};

export default ManageAuthorTags;
